import * as React from 'react';
import * as styles from '../index.css';

export interface IItemProps {
  name: string;
  value: string | number;
}

export function Item({ name, value }: IItemProps) {
  return (
    <div className={styles['item']}>
      <div className={styles['name']}>{name}</div>
      <div className={styles['value']}>{value}</div>
    </div>
  );
}
